module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II5.d8ea344f.png";